module.exports = __webpack_public_path__ + "img/yellowSquareBallone.aeefce55.png";